$('.sample-modal').on('closed.fndtn.reveal', function (e) {
    $('iframe#sample-dynamic-iframe').attr('src', 'about:blank');
});

$('body').on('closed.fndtn.dropdown', '.js-context-drop', function (e) {
    $(e.target).find('a').attr('tabindex', '-1');
});

$('body').on('opened.fndtn.dropdown', '.js-context-drop', function (e) {
    $(e.target).find('a').attr('tabindex', '0');
});

$('body').on(
    'click',
    'li.read-sample a, li.read-sample button, .button.sample',
    function (e) {
        let signInUrl = window.url(window.routes.accountSignIn, {
            forward: window.location.href,
        });
        let performSampleSignInRedirect =
            !window.OverDrive.isAuthenticated &&
            !window.OverDrive.allowAnonymousSampling;
        if (performSampleSignInRedirect) {
            e.stopImmediatePropagation();
            window.location.assign(signInUrl);
        } else {
            // If in mobile or in-app open sample link in new window. Else open in modal.
            var inApp = Cookies.get('omcbrowse') !== undefined;
            var target = $(e.target).closest('a, button');
            var isMediaDoTitle = false;

            //for samples on the home page
            if (target.attr('media-do-format')) {
                isMediaDoTitle =
                    target.attr('media-do-format') === 'true' ? true : false;
            }

            if (
                isMediaDoTitle === false &&
                window.OverDrive.mediaItems &&
                window.OverDrive.mediaItems !== ''
            ) {
                var title =
                    window.OverDrive.mediaItems[target.attr('data-media-id')];
                var formats = title['formats'];
                formats.forEach((ele) => {
                    if (ele['id'] === 'ebook-media-do') {
                        isMediaDoTitle = true;
                    }
                });
            }

            if (
                $(document).width() <= 640 ||
                target.attr('data-type') === 'video' ||
                target.attr('data-metro') ||
                inApp ||
                isMediaDoTitle
            ) {
                target.removeAttr('data-reveal-id');
                window.open(target.attr('data-href'), '_blank');
            } else {
                target.attr('data-reveal-id', 'sample-dynamic-modal');

                if (target.attr('data-href')) {
                    $('iframe#sample-dynamic-iframe').attr(
                        'src',
                        target.attr('data-href')
                    );
                    $('.modal-title[data-sample-title]').html(
                        target.attr('data-title')
                    );
                    $(document).foundation('reveal', 'reflow');
                }
            }
        }
    }
);
